import { IDropdownItem } from '@smartshell/ui-kit';

export const DISC_LETTERS: Array<IDropdownItem<number>> = [
  { title: 'A:', value: 1 },
  { title: 'B:', value: 2 },
  { title: 'C:', value: 4 },
  { title: 'D:', value: 8 },
  { title: 'E:', value: 16 },
  { title: 'F:', value: 32 },
  { title: 'G:', value: 64 },
  { title: 'H:', value: 128 },
  { title: 'I:', value: 256 },
  { title: 'J:', value: 512 },
  { title: 'K:', value: 1024 },
  { title: 'L:', value: 2048 },
  { title: 'M:', value: 4096 },
  { title: 'N:', value: 8192 },
  { title: 'O:', value: 16384 },
  { title: 'P:', value: 32768 },
  { title: 'Q:', value: 65536 },
  { title: 'R:', value: 131072 },
  { title: 'S:', value: 262144 },
  { title: 'T:', value: 524288 },
  { title: 'U:', value: 1048576 },
  { title: 'V:', value: 2097152 },
  { title: 'W:', value: 4194304 },
  { title: 'X:', value: 8388608 },
  { title: 'Y:', value: 16777216 },
  { title: 'Z:', value: 33554432 },
];

export const getDiscLetters = (hexStr: string): Array<number> => {
  const discLetters = [];
  const hex = parseInt(hexStr);

  for (let i = 0; i <= DISC_LETTERS.length - 1; i++) {
    if (hex & DISC_LETTERS[i].value) {
      discLetters.push(DISC_LETTERS[i].value);
    }
  }

  return discLetters;
};
